import React from 'react';
import TableAction from "../../strategyProject/tabs/TabResults/TableAction/TableAction";
import style from "../../strategyProject/tabs/TabResults/TabResults.module.less";
import useUserContext from '../../../hooks/useUserContext';
import grantAccess from '/img/icons/documents-components/grant-access.svg'
import pen from '/img/icons/documents-components/pen.svg'


const DocumentTableActions = ({props, actions}) => {
const userCtx = useUserContext();

const styles = {
    padding: '14px 15px', 
    width: '232px',
    flexDirection: 'column',
}

    return (
        <div style={{display: 'flex'}}>
            {(props.permissions.canRename || props.data.creatorId === userCtx.user.id || props.permissions.canDelete) && props.data.type === 'folder' ?
                <TableAction
                    tooltip=''
                    actionsDisabled={false}
                    style={styles}
                >
                    {(props.permissions.canRename || props.data.creatorId === userCtx.user.id) && props.data.type === 'folder' && <button
                            className={style.actionTableButtonDoc}
                            onClick={(e) => actions.rename(e, props.id)}
                        >
                           <img src={pen}/> Переименовать
                        </button>
                    }
                    {props.permissions.canAssignAccessToFolders && props.data.type === 'folder' && <button
                            className={style.actionTableButtonDoc}
                            onClick={(e) => actions.access(e, props.id)}
                        >
                            <img src={grantAccess}/> Предоставить доступ
                        </button>
                    }
                </TableAction>
                : <div style={{width: "49px"}}/>
            }
        </div>
    );
};

export default DocumentTableActions;